import React from 'react';
import { Eye } from 'lucide-react';
import { Button } from '../../ui/button';
import { Badge } from '../../ui/badge';
import { TableCell, TableRow } from '../../ui/table';
import type { Document } from '../../../api/documentApi';

export type { Document };

interface DocumentListTableRowProps {
  document: Document;
  moduleColors: Record<string, string>;
  statusColors: Record<string, string>;
}

export default function DocumentListTableRow({
  document,
  moduleColors,
  statusColors,
}: DocumentListTableRowProps) {
  return (
    <TableRow>
      <TableCell className="font-medium">{document.document_name || document.file_name}</TableCell>
      <TableCell>{document.entity_name || '-'}</TableCell>
      <TableCell>
        <Badge className={moduleColors[document.module_type || ''] || moduleColors.GENERAL}>
          {document.module_type || 'GENERAL'}
        </Badge>
      </TableCell>
      <TableCell className="font-mono text-sm">{document.document_ref_number || '-'}</TableCell>
      <TableCell className="text-sm">{document.created_date?.split('T')[0] || '-'}</TableCell>
      <TableCell>
        <Badge className={statusColors[document.status || ''] || statusColors.draft}>
          {document.status || 'draft'}
        </Badge>
      </TableCell>
      <TableCell>
        <div className="flex gap-2">
          {document.file_url && (
            <a href={document.file_url} target="_blank" rel="noopener noreferrer">
              <Button variant="ghost" size="icon">
                <Eye className="w-4 h-4" />
              </Button>
            </a>
          )}
        </div>
      </TableCell>
    </TableRow>
  );
}
